import React from 'react';
import { Box, Grid, Typography, styled, useTheme } from '@mui/material';
import WorkWithUsImg from '@sites/assets/workWithUs/workWithUs.png';
import { useSelector } from 'react-redux';

import { sxStyle } from './styles';

const BodyContainer = styled('div')(({ theme }) => ({
  backgroundColor: '#F6F6F6',
  [theme.breakpoints.down('md')]: {
    padding: 20,
  },
}));

export default () => {
  const theme = useTheme();

  const { id } = useSelector(store => store.pageConfiguration);

  const getEmailByIdSite = () => {
    let email;
    switch (id) {
      case 1:
        email = 'comunicacion@viajestdh.com.ar';
        break;
      case 2:
        email = 'comunicacion@git.com.ar';
        break;
    }
    return email;
  };

  return (
    <>
      <Grid container direction="column" sx={sxStyle.gridContainer}>
        <Grid container direction="column">
          <BodyContainer>
            <Box sx={sxStyle.title}>
              <Grid container direction="row" sx={sxStyle.titleWork}>
                <div
                  style={{
                    width: 8,
                    backgroundColor: theme.primary,
                    marginRight: 5,
                  }}
                ></div>
                <Typography
                  variant="h5"
                  fontSize={'bold'}
                  style={{ fontWeight: 'bold', color: 'black' }}
                >
                  {'Trabajá con nosotros'}
                </Typography>
              </Grid>
            </Box>

            <Grid container sx={sxStyle.subTitle}>
              <Grid item xs={9} sx={sxStyle.itemSubTitle}>
                <Typography sx={sxStyle.textSubTitle}>
                  Si estás interesado en trabajar con nosotros envíanos un
                  correo con una carta de presentación y tu CV a{' '}
                  <Typography
                    component="span"
                    sx={sxStyle.textSubTitle}
                    style={{ color: theme.tertiary }}
                  >
                    <a href={`mailto:${getEmailByIdSite()}`}>
                      {getEmailByIdSite()}
                    </a>
                  </Typography>
                </Typography>
              </Grid>
              <Grid item xs={3} sx={sxStyle.image}>
                <img
                  src={WorkWithUsImg}
                  style={{
                    borderRadius: '8px',
                    width: '100%',
                    height: '100%',
                  }}
                />
              </Grid>
            </Grid>
          </BodyContainer>
        </Grid>
      </Grid>
    </>
  );
};
